import { render, staticRenderFns } from "./banner4.vue?vue&type=template&id=2a7933b4&scoped=true&"
import script from "./banner4.vue?vue&type=script&lang=js&"
export * from "./banner4.vue?vue&type=script&lang=js&"
import style0 from "./banner4.vue?vue&type=style&index=0&id=2a7933b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7933b4",
  null
  
)

export default component.exports